import Reveal from "@/components/Reveal";

const interiorFiles = [
  "Screenshot 2026-08-31 at 6.49.23 PM.png",
  "Screenshot 2026-08-31 at 6.49.54 PM.png",
  "Screenshot 2026-08-31 at 6.50.14 PM.png",
  "Screenshot 2026-08-31 at 6.50.45 PM.png",
  "Screenshot 2026-08-31 at 6.51.28 PM.png",
  "Screenshot 2026-08-31 at 6.51.59 PM.png",
  "Screenshot 2026-08-31 at 6.52.17 PM.png",
  "Screenshot 2026-08-31 at 6.52.38 PM.png",
  "Screenshot 2026-08-31 at 6.52.54 PM.png",
  "Screenshot 2026-08-31 at 6.53.09 PM.png",
  "Screenshot 2026-08-31 at 6.53.25 PM.png",
  "Screenshot 2026-08-31 at 6.54.09 PM.png",
  "Screenshot 2026-08-31 at 6.54.26 PM.png",
  "Screenshot 2026-08-31 at 6.54.51 PM.png",
  "Screenshot 2026-08-31 at 6.56.13 PM.png",
  "Screenshot 2026-08-31 at 6.56.38 PM.png",
];

const assetPath = (file) => `/assets/interior/${encodeURIComponent(file)}`;

export default function InteriorCarousel() {
  const loop = [...interiorFiles, ...interiorFiles];

  return (
    <section className="editorial-section interior-section" id="interiors" aria-labelledby="interiors-heading">
      <div className="section-inner">
        <Reveal>
          <div className="image-section-intro">
            <div className="section-kicker">Inside the evening</div>
            <h2 className="image-section-title" id="interiors-heading">A room that keeps unfolding.</h2>
            <p className="image-section-description">Warm lights, patterned ceilings, long tables, and room for the evening to take its own shape.</p>
          </div>
        </Reveal>
        <Reveal delay={90}>
          <div className="interior-carousel" data-testid="interior-carousel">
            <div className="interior-track">
              {loop.map((file, index) => (
                <figure className="interior-frame" key={`${file}-${index}`}>
                  <img className="interior-carousel-image" src={assetPath(file)} alt={index < interiorFiles.length ? "Hashtag dining room interior" : ""} aria-hidden={index >= interiorFiles.length} />
                </figure>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
